import React from "react";

function Notfound () {
    return (
        <div className="notfound">
            <img 
            className="notfound-img"
            src="img/404rick.png"
            alt="404: page not found."
            />
        </div>
    );
}

export default Notfound;